import { staticRoutes } from '@config/staticRoutes';
import Link from 'next/link';
import type { ReactElement } from 'react';

import {
  SitemapItem,
  SitemapSection,
  SitemapWrapper,
} from './SitemapView.styled';
import type {
  SitemapSectionComponentProps,
  SitemapViewProps,
} from './SitemapView.types';

const SitemapSectionComponent = ({
  pageSet,
}: SitemapSectionComponentProps): ReactElement => (
  <SitemapSection>
    {pageSet.map(page => (
      <SitemapItem key={page.title}>
        <Link href={page.link}>
          <p>{page.title}</p>
        </Link>
      </SitemapItem>
    ))}
  </SitemapSection>
);

export const SitemapView = ({
  allPosts,
  allCategories,
}: SitemapViewProps): ReactElement => (
  <SitemapWrapper>
    <h1>🗺 Mapa strony</h1>
    <h2>Posty</h2>
    <SitemapSectionComponent pageSet={allPosts} />
    <h2>Kategorie</h2>
    <SitemapSectionComponent pageSet={allCategories} />
    <h2>Strony</h2>
    <SitemapSectionComponent pageSet={staticRoutes} />
  </SitemapWrapper>
);
